// @ts-nocheck
import styles from './ProductFlags.module.css';
import ProductFlagsDictionary from './ProductFlagsDictionary';

const ProductFlags = ({ flags }) => {
  const productFlags = Object.entries(ProductFlagsDictionary ?? {})?.map(([key, value]) =>
    flags?.[key] ? value.value : null
  );
  const filteredProductFlags = productFlags?.filter((flag) => flag !== null);

  return (
    <div className={styles.flagsContainer}>
      <span className={styles.flagContent}>
        {filteredProductFlags.map((flag, index) =>
          !flag ? null : (
            <div className={styles.flag} key={flag}>
              {flag}
              {index < filteredProductFlags.length - 1 ? <span>&bull;</span> : ''}
            </div>
          )
        )}
      </span>
    </div>
  );
};

export default ProductFlags;
